/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { breakpointInfix, MediaBreakpointUp } from '../mixins/_breakpoints.mixin';

export default ($) => css(
  Object.keys($.gridBreakpoints).map(breakpoint => {
    const infix = breakpointInfix($, breakpoint, $.gridBreakpoints);
    return new MediaBreakpointUp(breakpoint).include($, css`
      .float${infix}-left {
        float: left !important;
      }
      .float${infix}-right {
        float: right !important;
      }
      .float${infix}-none {
        float: none !important;
      }
    `);
  })
);
